export default "__VITE_ASSET__lgB8vr0o__"